import script from "./BannerTopPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BannerTopPage.vue?vue&type=script&setup=true&lang=js"

import "./BannerTopPage.vue?vue&type=style&index=0&id=2f1a242a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f1a242a"]])

export default __exports__